import type { FaireProductEntity } from "../../entity_types/product";

export const p_w4cqrmh3an: FaireProductEntity = {
  token: "p_w4cqrmh3an",
  type: "product",
  name: "Mango Con Chile (H)",
  brandToken: "b_dkshdskwmr",
  brandName: "King Henry's",
  imageUrl:
    "https://cdn.faire.com/fastly/3dd167c56d334190e5cde3edd8c94528b852f319cd6f922bd483d5d5cde7c6c6.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.52,
  description:
    "King Henry's presents the tantalizing Mango Con Chile (H). This delightful gummy confection brings together the sweet taste of mango with a kick of chile, offering a unique flavor combination that's sure to please. King Henry's, a woman-owned national snack company, has been dedicated to providing premium quality snacks at great value for over 30 years. Experience the richness of flavor in every bite with our Mango Con Chile (H), packed neatly in a case with dimensions of 11 7/16 x 9 7/16 x 3 1/2. Enjoy the diverse range of high-quality products from King Henry's.",
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:38.880Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
